/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-07T09:38:27.828
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getCCBContractEditInit,
	getCCBContractView
} from '@api/house/CCBContract';

import {
listCCBContractFeesInit,
listCCBContractFeesByAuthorizations,
deleteCCBContractFees
} from '@api/house/CCBContractFees';

import {
listCCBSyncLogInit,
listCCBSyncLogByAuthorizations,
deleteCCBSyncLog
} from '@api/house/CCBSyncLog';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getCCBContractEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBContractEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getCCBContractView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBContractView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
